import { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function PdfViewer({ data, zoom = 1, testId }) {
  const containerRef = useRef(null);
  const [status, setStatus] = useState("loading");
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const container = containerRef.current;
    if (!container || !data) return undefined;
    container.innerHTML = "";
    setStatus("loading");
    (async () => {
      try {
        const pdf = await pdfjsLib.getDocument({ data: data.slice(0) }).promise;
        if (cancelled) return;
        setPageCount(pdf.numPages);
        const dpr = window.devicePixelRatio || 1;
        for (let i = 1; i <= pdf.numPages; i += 1) {
          const page = await pdf.getPage(i);
          if (cancelled) return;
          const base = page.getViewport({ scale: 1 });
          const viewport = page.getViewport({ scale: (container.clientWidth / base.width) * zoom });
          const canvas = document.createElement("canvas");
          canvas.setAttribute("data-testid", `${testId}-page-${i}`);
          canvas.className = "w-full h-auto rounded-lg border shadow-sm mb-2 bg-white";
          canvas.width = Math.floor(viewport.width * dpr);
          canvas.height = Math.floor(viewport.height * dpr);
          container.appendChild(canvas);
          await page.render({
            canvasContext: canvas.getContext("2d"), viewport,
            transform: dpr !== 1 ? [dpr, 0, 0, dpr, 0, 0] : null,
          }).promise;
        }
        if (!cancelled) setStatus("done");
      } catch {
        if (!cancelled) setStatus("error");
      }
    })();
    return () => { cancelled = true; };
  }, [data, zoom, testId]);

  return (
    <div className="space-y-2" data-testid={testId}>
      {pageCount > 0 && (
        <p className="text-[10px] text-slate-400 text-center" data-testid={`${testId}-count`}>
          عدد الصفحات: {pageCount}
        </p>
      )}
      <div ref={containerRef} className="w-full" />
      {status === "loading" && (
        <p className="text-center text-xs text-slate-400 py-6">جارٍ تحميل الملف...</p>
      )}
      {status === "error" && (
        <p className="text-center text-xs font-bold text-rose-600 py-6">
          تعذر عرض الملف — جرّب «فتح في تبويب جديد»
        </p>
      )}
    </div>
  );
}

const ctx2d = (canvas) => canvas.getContext("2d");
